import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {LESSON} from "../../../../tenant/Config/ApiUrl";

const state =  {
    lesson: {},
}

const getters = {
    getLessonDetails: state => {
        return state.course
    }
};

const actions = {
    getLessonDetails({commit, state}, lessonId){
        commit('SET_LOADER', true)
        axiosGet(`${LESSON}/${lessonId}`).then(({ data }) =>{
            commit('LESSON_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
}

const mutations = {
    LESSON_DETAILS_DATA(state, data){
        state.lesson = data;
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}
